import * as fcl from "@onflow/fcl";
 fcl.config()
  .put("flow.network", "testnet")
  .put("accessNode.api", "https://rest-testnet.onflow.org")
  .put("discovery.wallet", "https://fcl-discovery.onflow.org/testnet/authn")
  .put("app.detail.title", "keyFlow")
  .put("app.detail.icon", "https://i.imgur.com/r23Zhvu.png")


export default fcl;  